var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},_vm._l((_vm.steps),function(ref,i){
var component = ref.component;
var disabled = ref.disabled;
var name = ref.name;
return _c('vx-tooltip',{key:i,staticClass:"w-16 h-full flex items-center justify-center",class:[
                disabled ? 'cursor-not-allowed text-gray': 'cursor-pointer',
                { 'hover:bg-primary-light': !disabled }
              ],attrs:{"position":"top","text":"No more history left","enabled":disabled && name.toLowerCase().includes('conversation')},nativeOn:{"click":function($event){return _vm.$emit('step', { disabled: disabled, name: name })}}},[_c(component,{key:i,tag:"component",staticClass:"h-4"})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }